var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import PageHeader from '@/components/page-header/PageHeader';
import ErrorHandler from '@/support/ErrorHandler';
import { StudentDocument, StudentDocumentIncludes } from '@/models/StudentDocument';
import SelectFilter from '@/components/select-filter/SelectFilter.vue';
import CreatePlanDialog from '../Groups/Tabs/Plan/CreatePlanDialog/CreatePlanDialog.vue';
let Documents = class Documents extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = this.$t('documents.title');
        this.documents = null;
        this.currentUserId = this.$store.state.Auth.id;
        this.filters = { created_by_or_shared_with: this.currentUserId, documentable_type: null };
        this.selectableItems = [
            { name: 'Groep', value: 'group' },
            { name: 'Leerling', value: 'user' },
        ];
        this.selectedItem = null;
        this.selectedDocument = null;
        this.isEditingDocument = false;
    }
    get tableOptions() {
        return {
            model: new StudentDocument()
                .include([StudentDocumentIncludes.DOCUMENTABLE, StudentDocumentIncludes.TEACHERS, StudentDocumentIncludes.CREATED_BY])
                .filter(this.filters),
            name: {
                singular: this.$tc('documents.label', 1),
                plural: this.$tc('documents.label', 2),
            },
            headers: [
                {
                    text: this.$t('documents.name'),
                    value: 'title',
                },
                {
                    text: this.$t('documents.connection'),
                    value: 'documentable_type',
                    slot: 'documentable_type',
                },
                {
                    text: this.$t('documents.connectionName'),
                    value: 'documentable',
                    slot: 'documentable'
                },
            ],
            actions: [
                {
                    type: 'edit',
                    label: 'download',
                    icon: 'download',
                    action: async (vm, documents) => {
                        const document = await new StudentDocument().include(StudentDocumentIncludes.FILE).find(documents.id);
                        window.open(document.file || '', '_blank');
                    },
                    visible: (vm, documents) => {
                        return !!(documents && documents.has_file);
                    },
                },
                {
                    type: 'edit',
                    label: 'edit',
                    icon: 'edit',
                    action: (vm, document) => this.editDocument(document),
                    visible: (vm, document) => {
                        const creatorUser = (document && document.created_by && document.created_by.id) || null;
                        const allowedTeachers = ((document && document.teachers) || []).filter((teacher) => teacher.permission === 'edit');
                        return this.currentUserId === creatorUser || allowedTeachers.some((teacher) => teacher.user.id === this.currentUserId);
                    },
                },
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, document) => {
                        this.openConfirmDeleteDialog(document);
                    },
                    visible: (vm, document) => {
                        return this.currentUserId === (document && document.created_by && document.created_by.id);
                    },
                },
            ],
            filters: [],
        };
    }
    //edit dialog
    editDocument(plan) {
        this.selectedDocument = plan;
    }
    onCreated() {
        this.refreshDataTable();
        this.closeDialog();
    }
    onUpdated() {
        this.refreshDataTable();
        this.closeDialog();
    }
    closeDialog() {
        this.isEditingDocument = false;
        this.selectedDocument = null;
    }
    //delete dialog
    openConfirmDeleteDialog(document) {
        this.$store.dispatch('openDialog', this.dialogOptions(document));
    }
    dialogOptions(document) {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('dialogOptions.item.project') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        document
                            .delete()
                            .then((response) => {
                            if (response) {
                                this.refreshDataTable();
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    get isDocumentDialogOpen() {
        return !!(this.selectedDocument || this.isEditingDocument);
    }
    set isDocumentDialogOpen(value) {
        this.closeDialog();
    }
};
Documents = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            SelectFilter,
            CreatePlanDialog,
        },
    })
], Documents);
export default Documents;
